import axios from "axios" 
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function ListUser() {

    const [users, setUsers] =  useState([]);
    
    useEffect(() => {
        getUsers();
    }, []);


    function getUsers() {
        axios.get("https://api.interfacedataanddesignllp.com/users/").then(function(response) {
            console.log(response.data);
            setUsers(response.data);
        });
    }

    const deleteUser =   (id) => {
        axios.delete(`https://api.interfacedataanddesignllp.com/user/edit/${id}/delete`).then(function(response){
            console.log(response.data);
            getUsers();
        });
    }
    return(
        <div>
        <h1>List Users</h1>
        <table cellPadding= "10px" border= "1px solid black">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {users.map((user,key) =>
                <tr key={key}>
                    <td>{user.id}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.mobile}</td>
                    <td>  
                        <Link to={`user/${user.id}/edit`}>Edit</Link>                    
                        <button onClick={()=> deleteUser(user.id)}>Delete</button>
                    </td>
                </tr>
            
)}
            </tbody>
        </table>
        </div>
        
    )
}